const statisticsHu = {
    "user_statistics": "Felhasználói statisztikák",
    "menu_item_clicks": "Étlap elem kattintások",
    "statistics": "Statisztikák",
    "user_traffic": "Felhasználói forgalom",
    "last_7_days": "Utolsó 7 nap",
    "last_30_days": "Utolsó 30 nap",
    "menu_item": "Étlap elem",
    "click_count": "Kattintások száma",
    "error_fetching_user_statistics": "Hiba a felhasználói statisztikák lekérésekor.",
    "error_fetching_menu_item_statistics": "Hiba az étlap elem statisztikák lekérésekor.",
    "statistics_feature_not_available": "A statisztikák funkció csak a PRO csomagban érhető el. Frissítsd az előfizetésed a funkció eléréséhez.",
    "change_subscription_plan": "Előfizetési csomag módosítása",
    "permission_denied": "Nincs jogosultságod hozzáférni ehhez az oldalhoz",
    "error_fetching_rating_statistics": "Hiba az értékelési statisztikák lekérésekor.",
    "menu_item_ratings": "Étlap elem értékelések",
    "likes": "tetszik",
    "dislikes": "nem tetszik",
    "rating_trends_last_7_days": "Értékelési trendek (utolsó 7 nap)",
    "rating_trends_last_30_days": "Értékelési trendek (utolsó 30 nap)",
    "kpi_total_visitors": "Összes látogató",
    "kpi_avg_per_day": "Átlag / nap",
    "kpi_peak_day": "Csúcsnap",
    "kpi_top_item": "Legtöbbet kattintott",
    "kpi_clicks": "kattintás",
    "kpi_vs_prev": "az előző időszakhoz képest",
    "current_period": "Jelenlegi időszak",
    "previous_period": "Előző időszak",
    "visitors": "látogató",
    "hourly_traffic": "Óránkénti forgalom",
    "utm_sources": "Forgalom forrása",
    "utm_unknown": "Ismeretlen",
    "no_data": "Nincs adat",
};

export default statisticsHu;